import {Component, OnInit, Inject} from '@angular/core';
import {BaseComponent} from "../../../../../../components/base/base.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {AuthenticationService} from "../../../../../../services/authenticate.service";
import {RoleModel} from 'src/app/modules/admin/models/role.model';
import {ActivatedRoute} from "@angular/router";
import {LocalStorageService} from "../../../../../../services/local-storage.service";
import {GlobalsService} from "../../../../../../services/globals.service";

declare const AppNoty: any;

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})

export class AdminUserProfileComponent extends BaseComponent implements OnInit {
    imageSrc: string = './assets/styles/default/images/user-default.png';
    avatar: File | null = null;
    form: FormGroup;
    userInfo: any;
    roles: RoleModel[] = [];
    
    constructor(@Inject(MAT_DIALOG_DATA)
                public data: any,
                private readonly dialogRef: MatDialogRef<AdminUserProfileComponent>,
                public override activatedRoute: ActivatedRoute,
                public override translate: TranslateService,
                private readonly authService: AuthenticationService,
                private readonly globalsService: GlobalsService,
                private readonly fb: FormBuilder,
                private readonly localStorageService: LocalStorageService) {
        super(authService, activatedRoute, translate);
        
        this.userInfo = this.currentUser;
        const user = this.localStorageService.getSettings()?.user || null;
        if (this.currentUser && user && this.currentUser.roleId !== user?.roleId) {
            this.currentUser.roleId = user?.roleId;
            this.currentUser.roleName = user?.roleName;
        }

        this.imageSrc = this.userInfo.avatar
            ? this.userInfo.avatar
            : this.imageSrc;
        
        this.form = this.fb.group({
            name: 'avatar',
            avatar: new FormControl(''),
            id: [this.userInfo?.userId, Validators.required],
            username: [this.userInfo?.username, Validators.required],
            email: [this.userInfo?.email, Validators.required]
        });
    }
    
    override ngOnInit(): void {
        this.form.controls['name'].disable();
    }

    changePhone(event: any) {
        const phoneControl = this.form.get('mobile');
        if (phoneControl) {
            if (event.target.value.length === 0) {
                phoneControl.clearValidators();
            } else {
                phoneControl.setValidators([Validators.pattern(/(84|0[35789])\d{8}\b/g)]);
            }
            phoneControl.updateValueAndValidity();
        }
    }

    saveUserInfo() {
        const encryptBody = this.environment.rsa.isActive || false;
        if (this.form.valid) {
            let body = this.form.value;
            /*this.userService.update(body, encryptBody).subscribe((result) => {
                if (result.status === 1) {
                    this.userInfo.mobile = result.data.user.mobile;
                    this.userInfo.telegramId = result.data.user.telegramId;
                    this.authService.setUserInLocalStorage(
                        this.userInfo
                    );
                    AppNoty.success([this.translate.instant('modules.brandSafety.admin.user.notify.updateUserSuccess')]);
                    this.dialogRef.close(true);
                    return;
                }

                AppNoty.error([this.translate.instant(result.message ? 'modules.brandSafety.admin.user.notify.' + result.message : 'modules.brandSafety.admin.user.notify.updateUserFailed')]);
            })*/
        }
    }
    
}
